module.exports = require("@gauzy/plugin-sentry");